import { Box, Grid } from '@mui/material';
import { AxiosError } from 'axios';
import { FormMessage } from 'components/Message';
import { FC, useState, useCallback, useEffect } from 'react';
import { VoucherService } from 'services/voucher.service';
import { IVoucherList } from 'types/Voucher';

interface IPagination {
  setVouchers: Function;
  currentPage: number;
  setMaxPage: Function;
  setLoading: Function;
}

export const VoucherPagination: FC<IPagination> = ({
  setVouchers,
  currentPage,
  setMaxPage,
  setLoading,
}) => {
  const [query] = useState('');
  const [inPage, setInPage] = useState(currentPage);

  const getVouchers = useCallback(
    async (page: number, filter: string) => {
      try {
        const maxPg = await VoucherService.getVoucherMaxPage(10, filter, true);

        if (maxPg) {
          setMaxPage(parseInt(maxPg));
        }

        const vouchers = await VoucherService.listAllVoucher(
          page,
          10,
          filter,
          true
        );
        return vouchers;
      } catch (error) {
        const { response } = error as AxiosError;
        return (
          <Box p={1}>
            <Grid container justifyContent="flex-end">
              <Grid item xs={6}>
                <FormMessage data={response?.data?.error} severity="error" />
              </Grid>
            </Grid>
          </Box>
        );
      }
    },
    [setMaxPage]
  );

  const getVouchersCb = useCallback(
    async (force = false) => {
      if (inPage !== currentPage || force === true) {
        const vouchers = await getVouchers(currentPage, query);
        setVouchers(vouchers);
      }
    },
    [setVouchers, inPage, query, currentPage, getVouchers]
  );

  useEffect(() => {
    getVouchers(1, '').then((vouchers: IVoucherList) => {
      setLoading(false);
      setVouchers(vouchers);
      setMaxPage(vouchers.totalPages);
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [setVouchers, getVouchers, setLoading]);

  useEffect(() => {
    setInPage(currentPage);
  }, [currentPage, setInPage, getVouchersCb]);

  useEffect(() => {
    getVouchersCb();
  }, [setInPage, getVouchersCb]);

  return <></>;
};

